import { Route } from '@angular/router';

import { ComplianceFacade } from '../services/compliance.facade';
import { ComplianceStore } from '../services/compliance.store';
import { TaxAuditFacade } from '../services/tax-audit.facade';
import { TaxAuditStore } from '../services/tax-audit.store';

export const TAX_AUDIT_ROUTES: Route[] = [
  {
    path: '',
    providers: [TaxAuditStore, TaxAuditFacade, ComplianceStore, ComplianceFacade],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('../pages/tax-audit-dashboard/tax-audit-dashboard.page').then((c) => c.TaxAuditDashboardPage),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('../pages/tax-audit-settings/tax-audit-settings.page').then((c) => c.TaxAuditSettingsPage),
      },
      {
        // Full width, for the same reason as `/dashboard/posts`: the audit-item detail panel is an
        // `at-sidenav-container` in sticky mode, and a sticky panel positions itself against the
        // viewport, so it only lines up with the content column while that column is uncapped.
        // See `dashboard.layout.scss`.
        path: ':year',
        data: { wideMainContent: true },
        loadComponent: () => import('../pages/tax-year-detail/tax-year-detail.page').then((c) => c.TaxYearDetailPage),
      },
      {
        path: ':year/evidence',
        loadComponent: () =>
          import('../pages/evidence-library/evidence-library.page').then((c) => c.EvidenceLibraryPage),
      },
    ],
  },
];
